import { createStore, applyMiddleware } from 'redux';
import reducer from './reducers';
import logger from './middlewares/logger';
import thunk from 'redux-thunk';

let store = createStore(reducer, applyMiddleware(logger, thunk));

export default store;